import Link from 'next/link';
import { SmartLinkProps } from '../contact-support.types';

export function SmartLink({ href, target, className, children }: SmartLinkProps) {
  if (!href) return <div className={className}>{children}</div>;
  const rel = target === '_blank' ? 'noopener noreferrer' : undefined;
  const isSpecial = href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('#');
  if (isSpecial) {
    return (
      <a href={href} target={target} rel={rel} className={className}>
        {children}
      </a>
    );
  }
  return (
    <Link href={href} target={target} rel={rel} className={className}>
      {children}
    </Link>
  );
}
